export default function isMatchingQuery(query: string, result: string) {
  const matchingWords = result.toLowerCase().match(query.toLowerCase());
  return matchingWords?.length ? [matchingWords[0]] : [];
}
